<template>
  <v-container fluid grid-list-xl>
    <app-diagnostico
      titulo="Avaliação da Equipe (Competências Técnicas)"
      :inicio="diagnostico.inicioResponsabilidadeChefia"
      :fim="diagnostico.fimResponsabilidadeChefia"
      :gestor-gestores="avaliacoesGestores.length > 0"
    >
      <template v-slot:body>
        <!-- Não há responsabilidades consolidadas para avaliar -->
        <v-col v-if="semResponsabilidades">
          <app-alert
            type="warning"
            icon="warning"
            message="Não há responsabilidades disponíveis para realizar a avaliação."
          />
        </v-col>

        <!-- Toda a equipe foi dispensada -->
        <v-col v-else-if="avaliacoes.length === 0">
          <info-dispensa
            :dispensas="dispensasEquipe"
            mensagem="Não é possível realizar a avaliação."
          />
        </v-col>

        <!-- Avaliação -->
        <v-col
          v-else
          centered
          cols="12"
          no-gutters
        >
          <!-- Abas -->
          <v-tabs
            v-model="categoria"
            color="secondary"
            centered
            icons-and-text
          >
            <v-tabs-slider color="secondary" />

            <!-- Geração das abas -->
            <v-tab
              v-for="i in categorias.length"
              :key="i"
              :href="'#' + categorias[i - 1].id"
              class="mt-3"
            >
              <span class="grey--text text--darken-2">{{ categorias[i - 1].descricao }}</span>
              <v-badge
                :color="categorias[i - 1].id === categoria ? 'secondary' : 'grey'"
                :content="categorias[i - 1].quantidade === 0 ? '0' : categorias[i - 1].quantidade"
              >
                <v-icon :color="categorias[i - 1].id === categoria ? 'secondary' : 'grey'">
                  {{ categorias[i - 1].icone }}
                </v-icon>
              </v-badge>
            </v-tab>

            <!-- Componentes -->
            <v-tabs-items v-model="categoria">
              <!-- Aba de avaliação dos gestores -->
              <v-tab-item v-if="avaliacoesGestores.length > 0" value="gestores">
                <!-- Avaliação -->
                <avaliacao
                  titulo="AVALIAÇÃO DA EQUIPE (GESTORES)"
                  :diagnostico="diagnostico"
                  tipo="SUBORDINADO"
                  perspectiva="RESPONSABILIDADE"
                  :inicio="diagnostico.inicioResponsabilidadeChefia"
                  :fim="diagnostico.fimResponsabilidadeChefia"
                  :tutorial="tutorial"
                  is-avaliacao-gestores
                >
                  <!-- Listagem de gestores sem responsabilidades -->
                  <template v-slot:default>
                    <avaliacao-gestores-sem-responsabilidades
                      v-if="avaliacoesGestoresSemResponsabilidades.length > 0"
                      :avaliacoes="avaliacoesGestoresSemResponsabilidades"
                    />
                  </template>
                </avaliacao>
              </v-tab-item>

              <!-- Aba de avaliação dos servidores -->
              <v-tab-item v-if="avaliacoesServidores.length > 0" value="servidores">
                <!-- Avaliação -->
                <avaliacao
                  titulo="AVALIAÇÃO DA EQUIPE (SERVIDORES)"
                  :diagnostico="diagnostico"
                  tipo="SUBORDINADO"
                  perspectiva="RESPONSABILIDADE"
                  :inicio="diagnostico.inicioResponsabilidadeChefia"
                  :fim="diagnostico.fimResponsabilidadeChefia"
                  :tutorial="tutorial"
                />
              </v-tab-item>

              <!-- Aba com os servidores dispensados do diagnóstico -->
              <v-tab-item
                v-if="dispensasEquipe.length > 0"
                value="dispensas"
              >
                <!-- Listagem de dispensados do diagnóstico -->
                <info-dispensa :dispensas="dispensasEquipe" />
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-col>
      </template>
    </app-diagnostico>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import AppDiagnostico from '@/components/core/AppDiagnostico';
import AppAlert from '@/components/core/AppAlert';
import InfoDispensa from '@/components/diagnostico/InfoDispensa';
import AvaliacaoGestoresSemResponsabilidades from '@/components/diagnostico/AvaliacaoGestoresSemResponsabilidades';
import Avaliacao from '@/components/diagnostico/Avaliacao';

export default {
  name: 'AvaliacaoDeServidoresResponsabilidade',

  components: {
    AppDiagnostico,
    AppAlert,
    InfoDispensa,
    AvaliacaoGestoresSemResponsabilidades,
    Avaliacao,
  },

  data() {
    return {
      categoria: '',
    };
  },

  computed: {
    ...mapState({
      diagnostico: (state) => state.diagnostico.diagnostico,
      isDispensado: (state) => state.diagnostico.dispensado,
      usuarioMapeamento: (state) => state.mapeamento.usuarioMapeamento,
      unidade: (state) => state.mapeamento.usuarioMapeamento.unidade,
    }),
    avaliacoes() {
      return this.$store.state.diagnostico.subordinadoResponsabilidade;
    },
    avaliacoesServidores() {
      return this.avaliacoes.filter((a) => a.avaliado.unidadeVersao.id === a.avaliador.unidadeVersao.id);
    },
    avaliacoesGestores() {
      return this.avaliacoes.filter((a) => a.avaliado.unidadeVersao.id !== a.avaliador.unidadeVersao.id);
    },
    avaliacoesGestoresSemResponsabilidades() {
      return this.avaliacoesGestores.filter(
        (a) => !this.$store.state.diagnostico.responsabilidades
          .some((r) => r.unidade.id === a.avaliado.unidadeVersao.id),
      );
    },
    dispensasEquipe() {
      return this.$store.state.diagnostico.dispensasEquipe.filter((d) => d.diagnostico.id === this.diagnostico.id);
    },
    tutorial() {
      let tutorial = '';

      if (this.avaliacoesGestores.length > 0) {
        tutorial = 'AvaliacaoEquipeResponsabilidadeGestorUnidades';
      } else {
        tutorial = 'AvaliacaoEquipeResponsabilidadeGestorUnidade';
      }

      return {
        nome: tutorial,
        nomeGenerico: 'AvaliacaoEquipeResponsabilidade',
      };
    },
    semResponsabilidades() {
      return this.$store.state.diagnostico.responsabilidades.length === 0;
    },
    categorias() {
      const categorias = [];
      if (this.avaliacoesGestores.length > 0) {
        categorias.push({
          id: 'gestores',
          descricao: 'Gestores',
          icone: 'person',
          quantidade: this.avaliacoesGestores.length,
        });
      }
      if (this.avaliacoesServidores.length > 0) {
        categorias.push({
          id: 'servidores',
          descricao: 'Servidores',
          icone: 'groups',
          quantidade: this.avaliacoesServidores.length,
        });
      }
      if (this.dispensasEquipe.length > 0) {
        categorias.push({
          id: 'dispensas',
          descricao: 'Dispensas',
          icone: 'hail',
          quantidade: this.dispensasEquipe.length,
        });
      }
      return categorias;
    },
  },

  watch: {
    categorias(value) {
      if (value.length > 0) {
        this.categoria = value[0].id;
      }
    },
  },
};
</script>
